import { Arbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/entities/Arbeitsbereich';
import { Beruf } from '@/domain/mitarbeiter/features/rotationsplan/entities/Beruf';
import { Mitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/entities/Mitarbeiter';
import { MitarbeiterKalenderStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import { transformMitarbeiterStationenToArbeitsbereichStationen } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/utils/transformData';

export const data: Mitarbeiter[] = [
  {
    id: 'm-1',
    vorname: 'Angelika',
    nachname: 'Müller',
    beruf: new Beruf({
      name: 'Hotelfachfrau',
      abkuerzung: 'HOFA',
      markierung: 'BROWN',
    }),
    lehrjahr: '1. Lehrjahr',
    stationen: [
      new MitarbeiterKalenderStation({
        id: '123456789_a',
        von: new Date('2026-01-02'),
        bis: new Date('2026-04-26'),
        arbeitsbereich: new Arbeitsbereich({
          id: 'ab1',
          name: 'Housekeeping',
          markierung: 'YELLOW',
        }),
      }),
      new MitarbeiterKalenderStation({
        id: '123456789_b',
        von: new Date('2026-04-27'),
        bis: new Date('2026-06-19'),
        arbeitsbereich: new Arbeitsbereich({
          id: 'ab2',
          name: 'Rezeption',
          markierung: 'BLUE',
        }),
      }),
    ],
  },
  {
    id: 'm-2',
    vorname: 'Lisa',
    nachname: 'Fischer',
    lehrjahr: '3. Lehrjahr',
    beruf: new Beruf({
      name: 'Test',
      abkuerzung: 'KAHO',
      markierung: 'RED',
    }),
    stationen: [
      new MitarbeiterKalenderStation({
        id: '123456789_c',
        von: new Date('2026-03-01'),
        bis: new Date('2026-04-24'),
        arbeitsbereich: new Arbeitsbereich({
          id: 'ab1',
          name: 'Housekeeping',
          markierung: 'YELLOW',
        }),
      }),
      new MitarbeiterKalenderStation({
        id: '123456789_d',
        von: new Date('2026-04-27'),
        bis: new Date('2026-06-12'),
        arbeitsbereich: new Arbeitsbereich({
          id: 'ab3',
          name: 'Service',
          markierung: 'GREEN',
        }),
      }),
      new MitarbeiterKalenderStation({
        id: '123456789_d',
        von: new Date('2026-06-15'),
        bis: new Date('2026-07-26'),
        arbeitsbereich: new Arbeitsbereich({
          id: 'ab2',
          name: 'Rezeption',
          markierung: 'BLUE',
        }),
      }),
    ],
  },
];

export const data2 =
  transformMitarbeiterStationenToArbeitsbereichStationen(data);
